import { Location } from '@cobliteam/common-types';
import { Button, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
      <Icon name='message-square-x' size='4xl' className='box-content overflow-visible rounded-full bg-primary-2 p-10' />
      <Typography variant='heading-2xl' as='h1'>
        404 Ops! Parece que essa página não existe
      </Typography>
      <Typography variant='input-placeholder'>Talvez a gente tenha movido essa página ou pode haver algum erro na url.</Typography>
      <Link to={Location.HOME}>
        <Button startIcon={<Icon name='house' />}>Voltar para a página inicial</Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
